export const SET_LOADING_DATA = '@focusSupplier/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@focusSupplier/SET_LOADING_SEND';
export const SET_LOADING_SELECTS = '@focusSupplier/SET_LOADING_SELECTS';

export const GET_LIST_FOCUS_SUPPLIER_REQUEST = '@focusSupplier/GET_LIST_FOCUS_SUPPLIER_REQUEST';
export const GET_LIST_FOCUS_SUPPLIER_SUCCESS = '@focusSupplier/GET_LIST_FOCUS_SUPPLIER_SUCCESS';

export const GET_BY_ID_REQUEST = '@focusSupplier/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@focusSupplier/GET_BY_ID_SUCCESS';

export const GET_SELECTS_SUCCESS = '@focusSupplier/GET_SELECTS_SUCCESS';

export const EDIT_ITEM = '@focusSupplier/EDIT_ITEM';
export const DELETE_ITEM = '@focusSupplier/DELETE_ITEM';

export const SAVE_FOCUS_SUPPLIER_REQUEST = '@focusSupplier/SAVE_FOCUS_SUPPLIER_REQUEST';
export const SAVE_FOCUS_SUPPLIER_SUCCESS = '@focusSupplier/SAVE_FOCUS_SUPPLIER_SUCCESS';

export const SET_PAGE = '@focusSupplier/SET_PAGE';
export const SET_ROWS_COUNT = '@focusSupplier/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@focusSupplier/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@focusSupplier/SET_ORDER';
export const SET_ORDERBY = '@focusSupplier/SET_ORDERBY';

export const SEARCH = '@focusSupplier/SEARCH';
